import React, { FC, ChangeEvent } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'

import {
  GenericTag,
} from '../../types/components'

interface StyleProps {
  color?: string,
}

const useStyles = makeStyles(theme => ({
  root: ({color}: StyleProps) => ({
    color: `${color}!important`,
  }),
  checked: ({color}: StyleProps) => ({
    color: `${color}!important`,
  }),
}))

interface TagCheckboxProps {
  tag: GenericTag,
  checked: boolean,
  readOnly?: boolean,
  onChange: {
    (id: string, checked: boolean): void,
  }
}

const TagCheckbox: FC<React.PropsWithChildren<TagCheckboxProps>> = ({
  tag,
  checked,
  readOnly,
  onChange
}) => {

  const classes = useStyles({color: tag.color?.color})

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(tag.id, event.target.checked)
  }

  return (
    <FormControlLabel
      control={
        <Checkbox
          className={ classes.root }
          classes={{
            root: classes.root,
            checked: classes.checked,
          } }
          checked={ checked }
          readOnly={ readOnly || false }
          disabled={ readOnly || false }
          onChange={ handleChange }
          name={ tag.id }
        />
      }
      label={ tag.name }
    />
  )
}

export default TagCheckbox